<template>
    <div>
        <b-button variant="primary" @click="abrirModal()"
            ><i class="fa fa-plus fa-lg"></i> Novo Item</b-button
        >
        <item-form
            :mostrarModal="mostrarModal"
            operacao="I"
            @fecharModal="mostrarModal = false"
            @atualizarListaItens="$emit('atualizarListaItens', $event)"
        ></item-form>
    </div>
</template>

<script>
import ItemForm from './ItemForm'

export default {
    components: {
        ItemForm
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        }
    }
}
</script>
